/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import {
    ApiParameter,
    HasPagingParameters,
    post,
    request,
    ServiceResult,
} from "@insite/client-framework/Services/ApiService";

export interface UploadTaxExemptParameter extends ApiParameter, HasPagingParameters {
    formData: any;
}

const url = "api/custom/account/TaxExemptEmail";

export async function uploadTaxExemptApi(parameter: UploadTaxExemptParameter): Promise<ServiceResult<any>> {
    try {
        const result = await request<any>(`${url}`, "POST", {}, parameter ? (parameter.formData as any) : undefined);
        return {
            result,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message,
            };
        }
        throw error;
    }
}
